import React, { useEffect, useState } from "react";
import axios from "axios";
import About from "@/components/About";
import Lookbook from "@/components/Lookbook";
import Notify from "@/components/Notify";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const LookbookPage = () => {
  const [tees, setTees] = useState([]);
  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API}/lookbook`);
        const normalized = (res.data || []).map((t) => ({
          ...t,
          image_url:
            t.image_url && t.image_url.startsWith("/")
              ? `${BACKEND_URL}${t.image_url}`
              : t.image_url,
        }));
        setTees(normalized);
      } catch (e) {
        console.error("[lookbook] failed to load tees:", e);
      }
    })();
  }, []);

  return (
    <div className="paper-overlay" data-testid="lookbook-page">
      <Lookbook tees={tees} />
      <About />
      <Notify />
    </div>
  );
};

export default LookbookPage;
